import React from "react";
import { Icon } from "@/components/Icon";

/* Keypad — the in-sheet numeric keypad for stake entry (design pattern #04:
   "never the OS keyboard"). 3×4 grid (1-9, ., 0, backspace) + a quick-stake chip
   row. Controlled: parent owns the stake string. Enforces a single decimal point
   and, for cash, max two decimal places. Quick chips add to the current stake;
   "Max" calls onMax. Source geometry: data-model `keys`/`quick`, template 3c. */

const GRID = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "back"];

export default function Keypad({ value = "", onChange, onMax, quick = ["+100", "+500", "+1K", "Max"], isCash = false }) {
  const press = (k) => {
    if (k === "back") { onChange(value.slice(0, -1)); return; }
    if (k === ".") {
      if (value.includes(".")) return;
      onChange((value === "" ? "0" : value) + ".");
      return;
    }
    // digit
    if (value.includes(".")) {
      const dec = value.split(".")[1] || "";
      if (isCash && dec.length >= 2) return; // cash caps at cents
    }
    if (value === "0") { onChange(k); return; } // replace leading zero
    onChange(value + k);
  };

  const quickAdd = (chip) => {
    if (chip === "Max") { onMax?.(); return; }
    const n = chip.replace(/[+$]/g, "").replace(/K$/i, "000");
    const add = Number(n) || 0;
    const cur = Number(value) || 0;
    const next = cur + add;
    onChange(isCash ? next.toFixed(2) : String(next));
  };

  const keyStyle = {
    height: 46, borderRadius: 12, background: "#1C1C21", color: "#fff",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,.06),0 1px 0 rgba(0,0,0,.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    font: "800 20px 'Manrope'", border: 0, cursor: "pointer",
  };

  return (
    <div style={{ background: "#0C0C0E", padding: "8px 8px calc(30px + env(safe-area-inset-bottom, 0px))", display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", gap: 8 }}>
        {quick.map((q) => (
          <button
            key={q} type="button" onClick={() => quickAdd(q)}
            style={{ flex: 1, height: 40, borderRadius: 10, background: "#1C1C21", color: "#D4D4D8", font: "700 13px 'Outfit'", border: 0, cursor: "pointer", boxShadow: "inset 0 0 0 1px rgba(255,255,255,.05)" }}
          >
            {q}
          </button>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 6 }}>
        {GRID.map((k) => (
          <button key={k} type="button" aria-label={k === "back" ? "Backspace" : k} onClick={() => press(k)} style={keyStyle}>
            {k === "back" ? <Icon name="backspace" size={22} className="text-white" /> : k}
          </button>
        ))}
      </div>
    </div>
  );
}
